import { __read } from "tslib";
/* eslint-disable @typescript-eslint/no-unsafe-call */
import * as u from '@virtuoso.dev/urx';
import { domIOSystem } from './domIOSystem';
import { initialTopMostItemIndexSystem } from './initialTopMostItemIndexSystem';
import { loggerSystem, LogLevel } from './loggerSystem';
import { propsReadySystem } from './propsReadySystem';
import { scrollToIndexSystem } from './scrollToIndexSystem';
import { sizeSystem } from './sizeSystem';
import { stateFlagsSystem } from './stateFlagsSystem';
function normalizeFollowOutput(follow) {
    if (!follow) {
        return false;
    }
    return follow === 'smooth' ? 'smooth' : 'auto';
}
var behaviorFromFollowOutput = function (follow, isAtBottom) {
    if (typeof follow === 'function') {
        return normalizeFollowOutput(follow(isAtBottom));
    }
    return isAtBottom && normalizeFollowOutput(follow);
};
export var followOutputSystem = u.system(function (_a) {
    var _b = __read(_a, 7), _c = _b[0], totalCount = _c.totalCount, listRefresh = _c.listRefresh, _d = _b[1], isAtBottom = _d.isAtBottom, atBottomState = _d.atBottomState, scrollToIndex = _b[2].scrollToIndex, scrolledToInitialItem = _b[3].scrolledToInitialItem, _e = _b[4], propsReady = _e.propsReady, didMount = _e.didMount, log = _b[5].log, scrollingInProgress = _b[6].scrollingInProgress;
    var followOutput = u.statefulStream(false);
    var pendingScrollHandle = null;
    function scrollToBottom(followOutputBehavior) {
        u.publish(scrollToIndex, {
            index: 'LAST',
            align: 'end',
            behavior: followOutputBehavior,
        });
    }
    u.subscribe(u.pipe(u.combineLatest(u.pipe(u.duc(totalCount), u.skip(1)), didMount), u.withLatestFrom(u.duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress), u.map(function (_a) {
        var _b = __read(_a, 5), _c = __read(_b[0], 2), totalCount = _c[0], didMount = _c[1], followOutput = _b[1], isAtBottom = _b[2], scrolledToInitialItem = _b[3], scrollingInProgress = _b[4];
        var shouldFollow = didMount && scrolledToInitialItem;
        var followOutputBehavior = 'auto';
        if (shouldFollow) {
            // if scrolling to index is in progress,
            // assume that a previous followOutput response is going
            followOutputBehavior = behaviorFromFollowOutput(followOutput, isAtBottom || scrollingInProgress);
            shouldFollow = shouldFollow && !!followOutputBehavior;
        }
        return { totalCount: totalCount, shouldFollow: shouldFollow, followOutputBehavior: followOutputBehavior };
    }), u.filter(function (_a) {
        var shouldFollow = _a.shouldFollow;
        return shouldFollow;
    })), function (_a) {
        var totalCount = _a.totalCount, followOutputBehavior = _a.followOutputBehavior;
        if (pendingScrollHandle) {
            pendingScrollHandle();
            pendingScrollHandle = null;
        }
        pendingScrollHandle = u.handleNext(listRefresh, function () {
            u.getValue(log)('following output to ', { totalCount: totalCount }, LogLevel.DEBUG);
            scrollToBottom(followOutputBehavior);
            pendingScrollHandle = null;
        });
    });
    u.subscribe(u.pipe(u.combineLatest(u.duc(followOutput), totalCount, propsReady), u.filter(function (_a) {
        var _b = __read(_a, 3), follow = _b[0], ready = _b[2];
        return follow && ready;
    }), u.scan(function (_a, _b) {
        var value = _a.value;
        var _c = __read(_b, 2), next = _c[1];
        return { refreshed: value === next, value: next };
    }, { refreshed: false, value: 0 }), u.filter(function (_a) {
        var refreshed = _a.refreshed;
        return refreshed;
    }), u.withLatestFrom(followOutput, totalCount)), function (_a) {
        var _b = __read(_a, 2), followOutput = _b[1];
        var cancel = u.handleNext(atBottomState, function (state) {
            if (followOutput &&
                !state.atBottom &&
                state.notAtBottomBecause === 'SIZE_INCREASED' &&
                !pendingScrollHandle) {
                u.getValue(log)('scrolling to bottom due to increased size', {}, LogLevel.DEBUG);
                scrollToBottom('auto');
            }
        });
        setTimeout(cancel, 100);
    });
    u.subscribe(u.combineLatest(u.duc(followOutput), atBottomState), function (_a) {
        var _b = __read(_a, 2), followOutput = _b[0], state = _b[1];
        if (followOutput &&
            !state.atBottom &&
            state.notAtBottomBecause === 'VIEWPORT_HEIGHT_DECREASING') {
            scrollToBottom('auto');
        }
    });
    return { followOutput: followOutput };
}, u.tup(sizeSystem, stateFlagsSystem, scrollToIndexSystem, initialTopMostItemIndexSystem, propsReadySystem, loggerSystem, domIOSystem));
